import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { InterfacePersonSearchViewModel, InterfacePersonSelectorByCustomerViewModel } from "src/Crm/interfacePersonSearch/interfacePersonSearch-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { DeliveryCartablesListViewModel } from "../deliveryCartablesList/deliveryCartablesList-viewModel";
import  { DeliveryFormView } from "./deliveryForm-view"

export class DeliveryFormViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.lineItems = ObservableArray.create();
        
    }
    GetDefaultView(): View <ViewModel> {
        return new DeliveryFormView();
    }
    public getTypeId(): string {
        return "VM-E2000E77-7DC9-4F92-8044-2F9CC26DAA7E"
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set warehousePartId(v: string) { this._warehousePartId = v; } public get warehousePartId(): string { return this._warehousePartId;} private _warehousePartId: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set collectorId(v: string) { this._collectorId = v; } public get collectorId(): string { return this._collectorId;} private _collectorId: string;
    public set collectorName(v: string) { this._collectorName = v; } public get collectorName(): string { return this._collectorName; } private _collectorName: string;
    public set receiverId(v: string) { this._receiverId = v; } public get receiverId(): string { return this._receiverId;} private _receiverId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set receiverLastName(v: string) { this._receiverLastName = v; } public get receiverLastName(): string { return this._receiverLastName;} private _receiverLastName: string;
    public set receiverPhone(v: string) { this._receiverPhone = v; } public get receiverPhone(): string { return this._receiverPhone;} private _receiverPhone: string;
    public set receiverComment(v: string) { this._receiverComment = v; } public get receiverComment(): string { return this._receiverComment;} private _receiverComment: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState; } private _warehouseState: number;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set isDeliveryFormPrinted(v: boolean) { this._isDeliveryFormPrinted = v; } public get isDeliveryFormPrinted(): boolean { return this._isDeliveryFormPrinted; } private _isDeliveryFormPrinted: boolean;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState; } private _paymentState: number;
    public set itemsCount(v: number) { this._itemsCount = v; } public get itemsCount(): number { return this._itemsCount;} private _itemsCount: number;
    public set interfacePersonsSelector(v: InterfacePersonSelectorByCustomerViewModel) { this._interfacePersonsSelector = v; } public get interfacePersonsSelector(): InterfacePersonSelectorByCustomerViewModel { return this._interfacePersonsSelector;} private _interfacePersonsSelector: InterfacePersonSelectorByCustomerViewModel;
    public set allInterfacePersonSearch(v: InterfacePersonSearchViewModel) { this._allInterfacePersonSearch = v; } public get allInterfacePersonSearch(): InterfacePersonSearchViewModel { return this._allInterfacePersonSearch;} private _allInterfacePersonSearch: InterfacePersonSearchViewModel;
    public set canDelivery(v: boolean) { this._canDelivery = v; } public get canDelivery(): boolean { return this._canDelivery;} private _canDelivery: boolean;
    public set canCollect(v: boolean) { this._canCollect = v; } public get canCollect(): boolean { return this._canCollect;} private _canCollect: boolean;
    public set lineItems(v: ObservableArray<DeliveryFormLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<DeliveryFormLineItem> { return this._lineItems; } private _lineItems: ObservableArray<DeliveryFormLineItem>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId:string, warehousePartId:string) :Promise<void>{
            let result = await ServerConnection.callServer('Complex/WarehouseServices/DeliveryCartableDetail', {
            InvoiceId: invoiceId,
            InvoiceWarehousePartId: warehousePartId,
        });
        this.id = result.InvoiceId;
        this.invoiceNumber = result.InvoiceNumber;
        this.warehousePartId = result.InvoiceWarehousePartId;
        this.creationTime = moment.utc(result.CreatedDate);
        this.customerId = result.CustomerId;
        this.customerName = result.CustomerName;
        this.sellerName = result.SellerName;
        this.collectorId = result.CollectorId;
        this.collectorName = result.CollectorName;
        this.receiverId = result.ReceiverId;
        this.receiverName = result.ReceiverName;
        this.districtName = result.DistrictName;
        this.saleFromWarehouseId = result.SaleFromWarehouseId;
        this.saleFromWarehouseName = result.SaleFromWarehouseName;
        this.deliveryWarehouseId = result.DeliveryWarehouseId;
        this.deliveryWarehouseName = result.DeliveryWarehouseName;
        this.isDeliveryFormPrinted = result.IsDeliveryFormPrinted;
        this.warehouseState = result.DeliveryWarehouseState;
        this.paymentState = result.PaymentState;
        this.canDelivery = this.warehouseState === 1 || this.warehouseState === 2 || this.warehouseState === 3;
        this.canCollect = this.warehouseState === 1 || this.warehouseState === 2;
        this.itemsCount = result.LineItems.length;
        
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new DeliveryFormLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.MeasuredProductId;
            r.productCarModel = q.ProductCarModel;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productIndex = q.ProductIndex;
            r.amount = q.Amount;
            r.counted = r.amount;
            r.unitName = q.Unit;
            r.stock = q.Stock;
            return r;
        }));
        this.interfacePersonsSelector = new InterfacePersonSelectorByCustomerViewModel(this, this.customerId);
        this.interfacePersonsSelector.onSelectionChanged = x=> {
            this.receiverId = x?.id;
            this.receiverName = x?.title;
            this.receiverLastName = `${x?.name} ${x?.lastName}`;
            this.receiverComment = x?.comment;
            this.receiverPhone = x?.phone;
        };
        this.allInterfacePersonSearch = new InterfacePersonSearchViewModel(this, this.customerId);
        this.allInterfacePersonSearch.onSelectionChanged = x=> {
            this.receiverId = x?.id;
            this.receiverName = x?.title;
            this.receiverLastName = `${x?.name} ${x?.lastName}`;
            this.receiverComment = x?.comment;
            this.receiverPhone = x?.phone;
        };
    }


    verifyDeliveryForm():string[]{
        let result :string[] =[];
        if(!this.lineItems.every(x=> {
            return x.counted === x.amount;
        })){
            result.push('شمارش کالاها صحیح نیست.')
        }
        if (stringIsNullOrEmpty(this.receiverId)) {
            result.push('تحویل گیرنده مشخص نشده است.')
        }
        return result;
    }

    verifyCreateReceiver():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.receiverPhone)){
            result.push('تلفن را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.receiverComment)){
            result.push('توضیحات را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.receiverLastName)){
            result.push('نام را وارد کنید.')
        }
        return result;
    }

    async delivery(){
        try {
            let verificationResult = this.verifyDeliveryForm();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت تحویل');
                return;
            }
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/WarehouseServices/DeliverWarehousePart',{
                InvoiceId:this.id,
                InvoiceWarehousePartId:this.warehousePartId,
                ReceiverId:this.receiverId,
            });
            await this.messageBoxConfirmSuccess('تحویل با موفقیت انجام شد.','عملیات موفق');
            this.closePopup("done");

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async createOrUpdateReceiver(){
        try {
            let verificationResult = this.verifyCreateReceiver();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت تحویل گیرنده');
                return;
            }
            this.isLoading = true;
            if (this.receiverId) {            
                let result = await ServerConnection.callServer('/Complex/CrmServices/UpdateCustomerInterface',{
                    Id:this.receiverId,
                    CustomerId:this.customerId,
                    Name:'',
                    Lastname:this.receiverLastName,
                    PhoneNumber:this.receiverPhone,
                    Comment:this.receiverComment
                });
                this.receiverId = result.InterfaceId;
                await this.messageBoxConfirmSuccess('تحویل گیرنده با موفقیت بروز شد.','عملیات موفق');
            } else {
                let result = await ServerConnection.callServer('/Complex/CrmServices/CreateInterfacePerson',{
                    Name:'',
                    CustomerId:this.customerId,
                    Lastname:this.receiverLastName,
                    PhoneNumber:this.receiverPhone,
                    Comment:this.receiverComment
                });
                this.receiverId = result.InterfaceId;
                await this.messageBoxConfirmSuccess('تحویل گیرنده با موفقیت ثبت شد.','عملیات موفق');
            }

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    closePopup(resultCode: string = null) {

    }
}

export class DeliveryFormLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set stock(v: number) { this._stock = v; } public get stock(): number { return this._stock; } private _stock: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set isCorrect(v: boolean) { this._isCorrect = v; } public get isCorrect(): boolean { return this._isCorrect;} private _isCorrect: boolean;
    public set isMore(v: boolean) { this._isMore = v; } public get isMore(): boolean { return this._isMore;} private _isMore: boolean;
    public set counted(v: number) { 
        this._counted = getAsNumber(v,true); 
        this.isCorrect = this.counted == this.amount;
        this.isMore = this.counted > this.amount;
    } public get counted(): number { return this._counted;} private _counted: number;

}
